class NumberFormatter {
    public toLocaleString(source: number, locales?: string | string[], options?: Intl.NumberFormatOptions): string {
        return source.toLocaleString(locales, options);
    }
}

export default new NumberFormatter();
